<template>
  <div>
    <el-form label-position="right" label-width="80px" inline class="table-expand">
      <el-form-item label="逻辑编号">
        <el-tag :style="tagStyle">{{ data.log_id?data.log_id:"无数据" }}</el-tag>
      </el-form-item>
      <el-form-item label="物理编号">
        <el-tag :style="tagStyle">{{ data.phy_id?data.phy_id:"无数据" }}</el-tag>
      </el-form-item>
      <el-form-item label="设备类型">
        <el-tag :style="tagStyle">{{data.dtype_source || data.dtype_move?`${data.dtype_source?data.dtype_source:""} ${data.dtype_move?data.dtype_move:""}`:"无数据"}}</el-tag>
      </el-form-item>
      <el-form-item label="网络类型">
        <el-tag :style="tagStyle">{{data.dtype_net?data.dtype_net:"无数据"}}</el-tag>
      </el-form-item>
      <el-form-item label="设备状态">
        <el-tag v-if="data.status_name" size="mini" :type="getTagType(data.status_name)">{{data.status_name}}</el-tag>
        <el-tag v-else :style="tagStyle">无数据</el-tag>
      </el-form-item>
      <el-form-item label="设备电量">
        <div v-if="data.battery">
          <el-progress type="circle" style="bottom:-8px;" :show-text="false" :stroke-width="6" :width="25" :percentage="data.battery"
            :color="getBatteryStatusColor(data.battery)"></el-progress>
          <span :style="tagStyle">{{`${data.battery}%`}}</span>
        </div>
        <el-tag v-else :style="tagStyle">无数据</el-tag>
      </el-form-item>
      <el-form-item label="心跳间隔">
        <el-tag :style="tagStyle">{{data.heartbeat?`${data.heartbeat}分`:"无数据"}}</el-tag>
      </el-form-item>
      <el-form-item label="上次心跳">
        <el-tag :style="tagStyle">{{data.last_heartbeat_time?data.last_heartbeat_time:"无记录"}}</el-tag>
      </el-form-item>
      <el-form-item label="设备地址">
        <el-tag :style="tagStyle">{{data.province || data.city || data.county || data.district || data.street || data.address? ` ${data.province?data.province:""}
          ${data.city?data.city:""} ${data.county?data.county:""} ${data.district?data.district:""} ${data.street?data.street:""}
          ${data.address?data.address:""}`:"无数据"}}
        </el-tag>
      </el-form-item>
      <el-form-item label="经纬坐标">
        <el-tag :style="tagStyle">{{ data.lon && data.lat?`${data.lon}E,${data.lat}N`:"无数据" }}</el-tag>
      </el-form-item>
      <el-form-item label="操作系统">
        <el-tag :style="tagStyle">{{data.dtype_os || data.os_version?`${data.dtype_os?data.dtype_os:""} ${data.os_version?data.os_version:""}`:"无数据"}}
        </el-tag>
      </el-form-item>
      <el-form-item label="系统更新">
        <el-tag :style="tagStyle">{{data.update_time?data.update_time:"无数据"}}
        </el-tag>
      </el-form-item>
      <el-form-item label="上线时间">
        <el-tag :style="tagStyle">{{ data.create_time?data.create_time:"无数据" }}</el-tag>
      </el-form-item>
      <el-form-item label="任务组别">
        <div v-if="data.task_id">
          <el-tag :style="`${tagStyle}padding-top:0;padding-bottom:0;padding-right:0;`">{{data.task_id}}
            <el-button @click="handleClickViewTask(data.task_id)">查看</el-button>
          </el-tag>
        </div>
        <el-tag v-else :style="tagStyle">未配置</el-tag>
      </el-form-item>
    </el-form>
    <el-dialog style="padding:0;" title="周期任务详情" :visible.sync="taskVisible" :close-on-click-modal='false' :append-to-body="true"
      width="570px">
      <PeriodTaskDetail ref="periodTaskDetail" :period-task-id="data.task_id"></PeriodTaskDetail>
    </el-dialog>
  </div>
</template>

<script>
  import PeriodTaskDetail from "@/components/Form/PeriodTaskDetail";
  export default {
    props: ["lgid"],
    components: {
      PeriodTaskDetail
    },
    watch: {
      lgid() {
        this.getData();
      }
    },
    mounted() {
      this.getData();
    },
    data() {
      return {
        taskVisible: false,
        data: {},
        tagStyle: "background-color:#fff;color:#999;height:22px;line-height:20px;"
      };
    },
    methods: {
      getData() {
        if (this.lgid) {
          this.$getJSON("/terminal/s_deviceDetail", {
            device_lgid: this.lgid
          }).then(res => {
            this.data = res.data[0];
          });
        }
      },
      handleClickViewTask(id) {
        this.taskVisible = true;
        if (this.$refs["periodTaskDetail"]) {
          this.$refs["periodTaskDetail"].getData();
        }
      },
      getBatteryStatusColor(percentage) {
        if (!percentage) {
          percentage = 0;
        }
        let cStart = [255, 0, 0];
        let cEnd = [0, 255, 0];
        let r, g, b;
        r = parseInt(cStart[0] + (cEnd[0] - cStart[0]) * percentage / 100);
        g = parseInt(cStart[1] + (cEnd[1] - cStart[1]) * percentage / 100);
        r = r < 0 ? 0 : r;
        r = r > 255 ? 255 : r;
        g = g < 0 ? 0 : g;
        g = g > 255 ? 255 : g;
        return `rgb(${r},${g},0)`
      },
      getTagType(text) {
        switch (text) {
          case "空闲":
            return "success";
          case "离线":
            return "info";
          default:
            return "warning";
        }
      }
    }
  };

</script>

<style scoped>
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    height: 28px;
  }

  .el-tag .el-button {
    margin: 0 0 0 5px;
    padding: 0 5px 0 5px;
    height: 100%;
  }

  .el-button {
    color: cornflowerblue;
    background-color: #ddd;
  }

  .el-dialog .el-dialog__header {
    padding: 5px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Form/DeviceDetail.vue